import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ShopService } from '../../shared/services/shop.service';
import { data } from 'src/app/data';
import { environment } from 'src/environments/environment';
import { SeoService } from 'src/app/shared/services';



@Component({
    selector: 'app-home',
    templateUrl: './page-home-one.component.html'
})
export class PageHomeOneComponent implements OnInit, OnDestroy {
    destroy$: Subject<void> = new Subject<void>();
    latestProducts = [];
    brands=data.brands;
    environment= environment;
    constructor(
        private shop: ShopService,
        private seoservice:SeoService
    ) { }

    ngOnInit(): void {
        this.seoservice.resetTags();
        this.shop.getRandomProducts().subscribe((res)=>{
            this.latestProducts = res;
        });

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }


}
